import { Head, useForm } from '@inertiajs/react'
import { AuthShell } from '@/components/auth/AuthShell'
import { Button, Field, Label, Input, Link } from '@/components/ui'
import { useTranslations } from '@/lib/i18n'

interface ForgotPasswordProps {
  sent: boolean
}

export default function ForgotPassword({ sent }: ForgotPasswordProps) {
  const { t } = useTranslations()
  const form = useForm({ email: '' })

  function submit(event: React.FormEvent) {
    event.preventDefault()
    form.transform((data) => ({ user: data }))
    form.post('/users/password')
  }

  return (
    <AuthShell title={t('auth.forgot_title')} subtitle={t('auth.forgot_subtitle')}>
      <Head title={t('auth.forgot_title')} />

      {sent ? (
        <p className="rounded-control bg-status-success-bg px-3 py-2 text-sm text-status-success-fg">
          {t('auth.reset_sent')}
        </p>
      ) : (
        <form onSubmit={submit} className="flex flex-col gap-5">
          <Field>
            <Label>{t('auth.email')}</Label>
            <Input
              type="email"
              name="email"
              autoComplete="email"
              autoFocus
              required
              value={form.data.email}
              onChange={(e) => form.setData('email', e.target.value)}
            />
          </Field>
          <Button type="submit" color="brand" disabled={form.processing} className="w-full">
            {t('auth.send_reset_link')}
          </Button>
        </form>
      )}

      <p className="mt-6 text-sm text-text">
        <Link href="/users/sign_in" className="font-medium text-text-strong underline">
          {t('auth.back_to_sign_in')}
        </Link>
      </p>
    </AuthShell>
  )
}
